<script lang="ts">
  import type {SvelteComponentTyped} from 'svelte';
  import {Link} from 'yrv';

  type Props<T> = T extends SvelteComponentTyped<infer P, any, any> ? P : never;
  interface $$Props extends Props<Link> {}
</script>

<style lang="postcss">
  :global(.linkButton) {
    display: inline-flex;
    height: var(--ubilabs-link-button-height);
    padding: var(--ubilabs-link-button-padding);
    background: none;
    outline: none;
    appearance: none;
    border: none;
    border-radius: var(--ubilabs-link-button-border-radius);
    background-color: var(--ubilabs-link-button-background-color);
    color: var(--ubilabs-link-button-label-color);
    font-family: var(--ubilabs-font-family);
    font-size: var(--ubilabs-link-button-font-size);
    font-weight: var(--ubilabs-link-button-font-weight);
    line-height: var(--ubilabs-link-button-line-height);
    letter-spacing: var(--ubilabs-link-button-letter-spacing);
    white-space: nowrap;
    text-decoration: none;
    text-transform: uppercase;
    cursor: default;
  }

  :global(.linkButton:not([disabled]):focus-visible) {
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  :global(.linkButton:not([disabled]):hover),
  :global(.linkButton:not([disabled]):focus-visible) {
    background-color: var(--ubilabs-link-button-hover-background-color);
    text-decoration: none;
  }

  :global(.linkButton:not([disabled]):active) {
    background-color: var(--ubilabs-link-button-active-background-color);
  }

  :global(.linkButton[disabled]) {
    background-color: var(--ubilabs-link-button-disabled-background-color);
    color: var(--ubilabs-link-button-disabled-label-color);
  }

  :global(.linkButton > [slot='icon']) {
    display: inline-flex;
    align-items: center;
    margin: 0 0.5em 0 -0.5em;
  }
</style>

<Link {...$$restProps} class="linkButton {$$props.class}" on:click>
  <slot name="icon" />
  <slot />
</Link>
